/* eslint-disable no-useless-escape */
export const validateEmail = (mail: string) => {
  if (/^[a-zA-Z0-9!#&~‘$*+/=?^`{|}_.%'[\]-]{1,64}@[a-zA-Z0-9][a-zA-Z0-9-]*(?:\.[a-zA-Z0-9][a-zA-Z0-9-]*)+$/.test(mail.trim())) {
    return false;
  }
  return true;
};
